var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.options),function(item,index){return [(_vm.values.includes(item.type))?[(_vm.color)?_c('a-tag',{attrs:{"color":_vm.getColor(index),"index":index}},[_vm._v(" "+_vm._s(item.name)+" ")]):_c('span',{attrs:{"index":index}},[_vm._v(" "+_vm._s(item.name)+" ")])]:_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }